import { GenericLazyString } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import './Banner.scss';

interface BannerProps {
    style?: string;
    header?: string | GenericLazyString;
    leftAccentColor?: string;
    children: React.ReactNode;
}

const Banner: React.FunctionComponent<BannerProps> = (props) => {
    const classes = classNames('banner', `banner--${props.style}`, {
        'banner--accent': props.leftAccentColor,
    });

    return (
        <div className={classes} style={{ borderColor: props.leftAccentColor }}>
            {props.header && (
                <div className="banner__header eds-text-bl">{props.header}</div>
            )}
            {props.children}
        </div>
    );
};

export default Banner;
